// extracted by mini-css-extract-plugin
export var card = "_ki-5";
export var cardSelected = "_ki-4";
export var image = "_ki-3";
export var modal = "_ki-0";
export var modalContent = "_ki-1";
export var table = "_ki-2";